import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Star } from 'lucide-react';

function PointsNode({ data, selected }: NodeProps) {
  const type = (data.type as string) ?? 'add_points';
  const config = (data.config as Record<string, unknown>) ?? {};
  const points = (config.points as number) ?? 0;
  const programSlug = (config.programSlug as string) ?? '';
  const isAdd = type === 'add_points';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-emerald-400 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-emerald-400" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Star size={14} className="text-emerald-400 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          {isAdd ? 'Add Points' : 'Remove Points'}
        </span>
      </div>
      <div className="px-3 py-2 space-y-0.5">
        <p className="text-xs text-zinc-500">Points</p>
        <p className="text-xs text-zinc-800 font-medium">
          {points ? (
            <span className={isAdd ? 'text-emerald-600' : 'text-red-500'}>
              {isAdd ? '+' : '-'}
              {points}
            </span>
          ) : (
            <span className="italic text-zinc-400">Not set</span>
          )}
        </p>
        {programSlug && (
          <>
            <p className="text-xs text-zinc-500 mt-1">Program</p>
            <p className="text-xs text-zinc-700 truncate">{programSlug}</p>
          </>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-emerald-400" />
    </div>
  );
}

export default memo(PointsNode);
